import AppRouter from "./routes/AppRouter";
import Clarity from "@microsoft/clarity";
import { useTranslation } from "react-i18next";
import "./App.css";
import { useEffect } from "react";
import setHtmlLangAttribute from "./utils/setHtmlLangAttribute";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./utils/ScrollToTop";

function App() {
  const { i18n } = useTranslation();

  const projectId = "qyhouo4ura";
  Clarity.init(projectId);

  useEffect(() => {
    setHtmlLangAttribute(i18n.language === "en" ? "en" : "uk");
  }, [i18n.language]);

  return (
    <div className="App">
      <ScrollToTop />
      <AppRouter />
      <Toaster />
    </div>
  );
}

export default App;
